/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { CreditCardEnum, Merchant } from "../../../../models";
import { MerchantDetailsParentComponent } from "../../merchant-details-parent.component";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, SharedFormService } from "../../../../services";
import { CREDIT_CARD_CONSTANTS } from "../../../../utils/data.rest.constants";

@Component({
  selector: "app-wp-accepted-credit-cards",
  templateUrl: "./wp-accepted-credit-cards.component.html"
})
export class WpAcceptedCreditCardsComponent extends MerchantDetailsParentComponent implements OnInit {
  editable = false;
  wpAcceptedCardsForm!: FormGroup;
  actionInProgress = false;
  buttonName = "Update Accepted Credit Cards";
  @Input("merchant") merchant!: Merchant;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder,
    private sharedFormService: SharedFormService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.wpAcceptedCardsForm = this.fb.group({
      acceptedCards: this.fb.group({})
    });
    this.sharedFormService.addCheckboxes(this.acceptedCardsFormGroup, this.merchant);
  }

  setEditable(value: boolean) {
    this.editable = value;
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
    this.createForm();
  }

  isInstaMed(): boolean {
    return this.merchantService.isInstaMed(this.merchant);
  }

  isAmexFeeRequired(): boolean {
    const isAmexCard = this.acceptedCardsFormGroup.get(CREDIT_CARD_CONSTANTS.CREDIT_CARDS.AMEX.code)?.value;
    const amexPaymentFee = this.merchant.contractedRates.amexPercent;
    return (this.isInstaMed() || this.isWorldPay()) && isAmexCard && amexPaymentFee === null;
  }

  updateElementMerchant() {
    if (this.isAmexFeeRequired()) {
      this.acceptedCardsFormGroup
        .get(CREDIT_CARD_CONSTANTS.CREDIT_CARDS.AMEX.code)
        ?.setErrors({ invalidAmexFee: true });
    }
    if (this.acceptedCardsFormGroup.valid) {
      this.actionInProgress = true;
      this.setFeeDetailsToNullIfNoneExist(this.merchant);
      const updatedCreditCardList: CreditCardEnum[] = [];
      Object.keys(this.acceptedCardsFormGroup.controls).forEach((key) => {
        if (this.acceptedCardsFormGroup.get(key)?.value) {
          updatedCreditCardList.push(<CreditCardEnum>key);
        }
      });
      this.merchantService.updateCreditCards(updatedCreditCardList, this.merchant).subscribe(
        (ccList) => {
          this.merchant.acceptedCreditCards = ccList;
          this.editable = false;
          this.actionInProgress = false;
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.acceptedCardsFormGroup.markAllAsTouched();
      this.actionInProgress = false;
    }
  }

  get acceptedCardsFormGroup(): FormGroup {
    return this.wpAcceptedCardsForm.controls["acceptedCards"] as FormGroup;
  }
}
